export const noop: (...args: unknown[]) => void = () => null;
